import { render, staticRenderFns } from "./OfertText.vue?vue&type=template&id=4ba56bb4&scoped=true"
import script from "./OfertText.vue?vue&type=script&lang=js"
export * from "./OfertText.vue?vue&type=script&lang=js"
import style0 from "./OfertText.vue?vue&type=style&index=0&id=4ba56bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba56bb4",
  null
  
)

export default component.exports